import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * Updates the LISP prefetch functionality
 */
export const FE_ENHANCE_LISP_PREFETCH_250916 = experiment({
  name: "FE_ENHANCE_LISP_PREFETCH_250916",
  identifier: "RetailerTokenInSession",
  client: ["RETAILER"],
  notifyAfter: "2026-01-10",
  defaultValue: false,
  productArea: "SEARCH",
});
